import React from 'react';
import { createPortal } from 'react-dom';

function RecruitModal({ job, onClose }) {
    // モーダル本体の構造を定義
    const modalContent = (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[50]"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg p-6 max-w-xl w-full relative text-black overflow-y-auto"
                style={{
                    position: 'fixed', // 表示画面に対して固定配置
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)', // 常に中央に表示
                    maxHeight: '90vh', // 高さ制限でモバイル対応
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="absolute top-3 right-3 text-gray-500 hover:text-black"
                    onClick={onClose}
                >
                    ×
                </button>
                <h3 className="text-2xl font-bold mb-4">{job.title}</h3>
                <ul className="space-y-2 text-sm">
                    <li><strong>職務内容<br /></strong> {job.description}</li>
                    <li><strong>勤務地<br /></strong> {job.location}</li>
                    <li>
                        <strong>必要スキル<br /></strong> 
                        <div 
                            dangerouslySetInnerHTML={{ __html: job.skills }}
                        />
                    </li>
                </ul>
                <div className="mt-6 text-center">
                    <a
                        href="#contact"
                        className="inline-block px-6 py-2 rounded-full bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-500 text-white font-semibold shadow hover:scale-105 transition"
                    >
                        応募・お問い合わせ
                    </a>
                </div>
            </div>
        </div>
    );

    // React Portal を使って body 配下に描画（DOMツリーの外に出す）
    return createPortal(modalContent, document.body);
}

export default RecruitModal;
